import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';

const data = [
    {
        name: 'AMES',
        actual: 4000,
        plan: 2400,
        forecast: 3000,
        amt: 2400,
    },
    {
        name: 'PBNA',
        actual: 3000,
        plan: 1398,
        forecast: 1400,
        amt: 2210,
    },
    {
        name: 'APAC',
        actual: 2000,
        plan: 9800,
        forecast: 2300,
        amt: 2290,
    },
    {
        name: 'LATAM',
        actual: 2780,
        plan: 3908,
        forecast: 4300,
        amt: 2000,
    },
];

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
                <div style={{ color: "#33ABDA" }}>{payload[0].payload.name}</div>
                <div style={{ color: "#0078A7" }}>Actual: {payload[0].value}</div>
                <div style={{ color: "#B05788" }}>YTD Plan: {payload[1].value}</div>
                {/* <div style={{ color: "#FF891C" }}>Forecast: {payload[2].value}</div> */}
            </div>
        );
    }

    return null;
};

function YTDProductivityChart({ data }) {
    // console.log("Pcdata", data)
    const sortedData = data?.slice()?.sort((a, b) => (a.name === null ? 1 : b.name === null ? -1 : 0));
    return (
        // <div style={{ width: "100%", height: "400px", overflowY: "auto" }}>
        //     <div style={{ width: '100%', height: `${data.length * 50}px` }}>
        <ResponsiveContainer width="100%" height={300}>
            <BarChart
                width={500}
                height={300}
                data={sortedData}
                margin={{
                    top: 20,
                    right: 30,
                    left: 0,
                    bottom: 25,
                }}
            >
                <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />
                <XAxis dataKey="name" axisLine={false}
                    tickLine={false} interval={0} scaleToFit allowDataOverflow={true}
                    width={100} tick={{ fontSize: 12, wordBreak: "break-word", width: 50 }}
                    tickFormatter={(value) => {
                        return (value == null || String(value).trim() === "" ? "NULL" : value)
                    }
                    } />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip cursor={false} content={CustomTooltip} />
                <Bar dataKey="actual" fill="#0078A7" barSize={24} >
                    {/* <LabelList dataKey="actual" position="top" offset={10} style={{ fontSize: 10, fontWeight: 700, color: "#3A3A3A" }} /> */}
                </Bar>
                <Bar dataKey="plan" fill="#B05788" barSize={24} >
                    {/* <LabelList dataKey="plan" position="top" offset={10} style={{ fontSize: 10, fontWeight: 700, color: "#3A3A3A" }} /> */}
                </Bar>
                {/* <Bar dataKey="forecast" fill="#FF891C" barSize={24}> */}
                {/* <LabelList dataKey="forecast" position="top" offset={10} style={{ fontSize: 10, fontWeight: 700, color: "#3A3A3A" }} /> */}
                {/* </Bar> */}
            </BarChart>
        </ResponsiveContainer>
        //     </div>
        // </div>
    )
}

export default YTDProductivityChart
